// MwPageShell: Layout wrapper for MW pages.
// NOTE: The nav is handled by MwNavBar in AppShell. MwPageShell only
// provides the content wrapper (background, max-width) and optional footer.

import type { ReactNode } from 'react'
import { MwFooter } from './MwFooter'

interface MwPageShellProps {
  children: ReactNode
  background?: 'white' | 'section'
  layout?: 'centered' | 'full'
  showFooter?: boolean
}

export function MwPageShell({
  children,
  background = 'section',
  layout = 'centered',
  showFooter = true,
}: MwPageShellProps) {
  return (
    <>
      <main
        style={{
          flex: 1,
          background: background === 'white' ? 'white' : 'var(--mw-surface-section)',
        }}
      >
        <div
          style={{
            maxWidth: layout === 'centered' ? 'var(--mw-w-content)' : 'var(--mw-w-page)',
            margin: '0 auto',
            padding: layout === 'centered' ? '48px var(--mw-p-page)' : '32px var(--mw-p-page)',
          }}
        >
          {children}
        </div>
      </main>
      {showFooter && <MwFooter />}
    </>
  )
}
